import React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

export interface FeedbackButtonsObjProps {
  buttonText: {
    cancelText: string
    submitText: string
  }
  errorMessage?: string
  feedbackMessage?: string
}

export interface FeedbackButtonsProps extends FeedbackButtonsObjProps {
  onCancel: () => void
  onClose: () => void
  selectedRadio?: number
}

export const FeedbackButtons: React.FC<FeedbackButtonsProps> = ({
  buttonText,
  errorMessage,
  feedbackMessage,
  onCancel,
  onClose,
  selectedRadio,
}) => {
  const { cancelText, submitText } = buttonText

  const disabled = (!feedbackMessage && selectedRadio === undefined) || !!errorMessage

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginTop: 24,
      }}
    >
      <Button
        className="mx-insights-beat-feedback-submit-button"
        data-ui-test="submit-button"
        disabled={disabled}
        sx={{
          fontSize: 16,
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
          padding: `12px 16px`,
          width: '100%',
        }}
        type="submit"
        variant="contained"
      >
        {submitText}
      </Button>

      <Button
        className="mx-insights-beat-feedback-no-thanks-button"
        data-ui-test="no-thanks-button"
        onClick={() => {
          onCancel()
          onClose()
        }}
        sx={{
          fontSize: 15,
          marginTop: 12,
          width: '100%',
        }}
        variant="text"
      >
        {cancelText}
      </Button>
    </Box>
  )
}
